import React, { useMemo, useState } from 'react';

function getFilterNames(widget) {
  var primary = widget.filterName || (widget.data && widget.data.filterName) || '';
  var end = widget.endFilterName || (widget.data && widget.data.endFilterName) || '';

  return {
    primary,
    end
  };
}

export default function DateFilterWidget({ widget, onFilterChange, setFilterParam }) {
  var names = useMemo(function () {
    return getFilterNames(widget || {});
  }, [widget]);

  var [startValue, setStartValue] = useState('');
  var [endValue, setEndValue] = useState('');

  var emitPrimary = function emitPrimary(value) {
    if (setFilterParam && names.primary) {
      setFilterParam(names.primary, value || null);
      return;
    }

    if (onFilterChange && names.primary) {
      onFilterChange(value || null);
    }
  };

  if (!names.end) {
    return (
      <div className="re-filter-body">
        <input
          type="date"
          value={startValue}
          onChange={function onChange(event) {
            var value = event.target.value;
            setStartValue(value);
            emitPrimary(value);
          }}
        />
      </div>
    );
  }

  return (
    <div className="re-filter-body re-filter-range">
      <input
        type="date"
        value={startValue}
        placeholder="Start"
        onChange={function onChange(event) {
          var value = event.target.value;
          setStartValue(value);
          emitPrimary(value);
        }}
      />
      <input
        type="date"
        value={endValue}
        placeholder="End"
        onChange={function onChange(event) {
          var value = event.target.value;
          setEndValue(value);
          if (setFilterParam && names.end) {
            setFilterParam(names.end, value || null);
          }
        }}
      />
    </div>
  );
}
